import { emptyRows, queryResultFromRows, } from "@evolu/common";
import { constVoid } from "effect/Function";
import { useEffect, useMemo, useRef, useSyncExternalStore } from "react";
import { useEvolu } from "./useEvolu.js";
/** Subscribe to {@link Query} {@link QueryResult} changes. */
export const useQuerySubscription = (query, options = {}) => {
    const evolu = useEvolu();
    // useRef to not break "rules-of-hooks"
    const { once } = useRef(options).current;
    if (once) {
        /* eslint-disable react-hooks/rules-of-hooks */
        useEffect(
        // No useSyncExternalStore, no unnecessary updates.
        () => evolu.subscribeQuery(query)(constVoid), [evolu, query]);
        return evolu.getQuery(query);
    }
    return useSyncExternalStore(useMemo(() => evolu.subscribeQuery(query), [evolu, query]), useMemo(() => () => evolu.getQuery(query), [evolu, query]), () => queryResultFromRows(emptyRows()));
};
